
import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { IonicSharedModule } from './ionic-shared.module';
import { AuthService } from './services/auth.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoadingController, AlertController, Platform, IonModal } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Capacitor } from '@capacitor/core';
import { environment } from './../environments/environment';
import { UserService } from './services/user.service';
import { AnimalService } from './services/animal.service';
import { AgendaService } from './services/agenda.service';
import { Animal } from './models/animal';
import { AgendaEvent } from './models/agenda';
import { App, URLOpenListenerEvent } from '@capacitor/app';

import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { User } from './models/user';
import { MenuController } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { StatusBar, Style } from '@capacitor/status-bar';

import DataLabelsPlugin from 'chartjs-plugin-datalabels';
import { Chart, registerables } from 'chart.js';
Chart.register(DataLabelsPlugin, ...registerables);

import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update';

import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';

import { Share } from '@capacitor/share';
import { register } from 'swiper/element/bundle';
register()

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr, 'fr-FR');

import { FirebaseMessaging, GetTokenOptions } from '@capacitor-firebase/messaging';
import { initializeApp as initializeAppFirebase } from 'firebase/app';
import { isPlatformBrowser } from "@angular/common";
import { PLATFORM_ID, Inject } from '@angular/core';
import { StorageService } from './services/storage.service';
import { DOCUMENT } from '@angular/common';
import { MetaService } from './services/meta.service';
import { EventsService } from './services/events.service';
import { Transaction, NativePurchases, PURCHASE_TYPE } from '@capgo/native-purchases';
import { OrganizationService } from './services/organization.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonicSharedModule]
})
export class AppComponent {
  environment = environment
  @ViewChild('modalLangSelector', { static: false }) modalLangSelector!: IonModal;

  showTabBar: boolean = true;
  isLoggedIn:boolean = false;

  pushNotificationsTokenValue: any = null;
  pushNotificationsOptions: any = null;
  pushNotificationsOptionsAlertControler: any = null;
  pushNotificationsRunning: any = false

  notifId: string | null = null;
  notifTitle: string | null = null;
  notifBody: string | null = null;
  notifUrl: string | null = null;


  languagesSortedbyName: { [key: string]: any }[] = []
  languages: { [key: string]: any }[] = [
    { 'id': '14', 'code': 'en-GB', 'code_short': 'en', 'name': 'English', 'prefix': '<span class="fi fi-gb"></span>' },
    { 'id': '5', 'code': 'fr-FR', 'code_short': 'fr', 'name': 'France', 'prefix': '<span class="fi fi-fr"></span>' },
    { 'id': '0', 'code': 'de-AT', 'code_short': 'de', 'name': 'Austria', 'prefix': '<span class="fi fi-at"></span>' },
    { 'id': '1', 'code': 'fr-BE', 'code_short': 'fr', 'name': 'Belgium (French)', 'prefix': '<span class="fi fi-be"></span>' },
    { 'id': '10', 'code': 'nl-NL', 'code_short': 'nl', 'name': 'Netherlands', 'prefix': '<span class="fi fi-nl"></span>' },
    { 'id': '2', 'code': 'nl-BE', 'code_short': 'nl', 'name': 'Belgium (Dutch)', 'prefix': '<span class="fi fi-be"></span>' },
    { 'id': '3', 'code': 'da-DK', 'code_short': 'da', 'name': 'Denmark', 'prefix': '<span class="fi fi-dk"></span>' },
    { 'id': '4', 'code': 'fi-FI', 'code_short': 'fi', 'name': 'Finland', 'prefix': '<span class="fi fi-ie"></span>' },
    { 'id': '6', 'code': 'de-DE', 'code_short': 'de', 'name': 'Germany', 'prefix': '<span class="fi fi-de"></span>' },
    { 'id': '7', 'code': 'en-IE', 'code_short': 'en', 'name': 'Finland (English)', 'prefix': '<span class="fi fi-ie"></span>' },
    { 'id': '8', 'code': 'fi-FI', 'code_short': 'fi', 'name': 'Ireland', 'prefix': '<span class="fi fi-fi"></span>' },
    { 'id': '9', 'code': 'it-IT', 'code_short': 'it', 'name': 'Italy', 'prefix': '<span class="fi fi-it"></span>' },
    { 'id': '11', 'code': 'pt-PT', 'code_short': 'pt', 'name': 'Portugal', 'prefix': '<span class="fi fi-pt"></span>' },
    { 'id': '12', 'code': 'es-ES', 'code_short': 'es', 'name': 'Spain', 'prefix': '<span class="fi fi-es"></span>' },
    { 'id': '13', 'code': 'sv-SE', 'code_short': 'sv', 'name': 'Sweden', 'prefix': '<span class="fi fi-se"></span>' },
    { 'id': '15', 'code': 'en-US', 'code_short': 'en', 'name': 'United States Of America', 'prefix': '<span class="fi fi-us"></span>' },
    { 'id': '16', 'code': 'cs-CZ', 'code_short': 'cs', 'name': 'Česky', 'prefix': '<span class="fi fi-cz"></span>' },
  ]
  currentLang: { [key: string]: any } | null = null;
  languageCode: string | null = null

  setLangFromNavigator() {
    var lang = null;
    var found = false;

    if (isPlatformBrowser(this.platformId)) {
      var userLangNavigator = navigator.language
      for (var l in this.languages) {
        if (this.languages[l]['code'].toLowerCase() == userLangNavigator.toLowerCase()) {
          lang = this.languages[l]
          found = true;
          break;
        }
      }
      if (!found) {
        userLangNavigator = navigator.language.split('-')[0];
        for (var l in this.languages) {
          if (this.languages[l]['code_short'].toLowerCase() == userLangNavigator.toLowerCase()) {
            lang = this.languages[l]
            found = true;
            break;
          }
        }
      }
    }

    if (!found) {
      for (var _l in this.languages) {
        var __l = this.languages[_l];
        if (__l['code'] == (isPlatformBrowser(this.platformId) ? 'en-GB' : 'fr-FR')) {
          lang = __l;
          break;
        }
      }
      lang = this.languages[14]
    }

    this.setLang(lang, true)
  }


  setLang(lang: { [key: string]: any } | null, isFromNavigatorOrLocaldatabase: boolean) {
    if(lang == null) return;
    
    if (!this.authService.isLoggedIn || (this.userService.user && !this.userService.user.languageCode) || !isFromNavigatorOrLocaldatabase) {
      this.translate.setDefaultLang('en');
      this.translate.use(lang['code_short']);
      environment.API_URL = environment.API_URL_CLEAR + lang['code_short'] + '/'
      this.document.documentElement.lang = lang['code_short'];
      this.currentLang = lang;

      if (this.storageService != null && this.storageService.configuration != null
        && (this.storageService.configuration.language == null || this.storageService.configuration.language['code_short'] != lang['code_short'])) {
        this.storageService.configuration.language = lang;
        this.storageService.saveConfiguration();
      }
      this.setLanguageCode(this.currentLang['code_short'])
      setTimeout(() => { this.updateMetaTranslations(); }, 500)
      setTimeout(() => { this.updateMetaTranslations(); }, 1000)
      setTimeout(() => { this.updateMetaTranslations(); }, 1500)
    }
  }

  setLanguageCode(languageCode: string) {
    if (this.authService.isLoggedIn && (!this.languageCode || this.languageCode != languageCode)) {
      this.languageCode = languageCode

      if (this.languageCode != this.userService.user?.languageCode) {
        if(this.userService.user)
          this.userService.user.languageCode = languageCode;

        var headers = new HttpHeaders({
          'Authorization': this.userService.getHttpHeaders()
        });
        this.http.get(environment.API_URL + 'userProfile/ws_private/' + languageCode + '/setLanguageCode/', { headers: headers }).subscribe(async (response: { [key: string]: any }) => {
        });
      }
    }
  }

  constructor(
    private authService: AuthService,
    public userService: UserService,
    private router: Router,
    private translate: TranslateService,
    public fb: FormBuilder,
    public loadingController: LoadingController,
    public platform: Platform,
    private http: HttpClient,
    public alertController: AlertController,
    @Inject(PLATFORM_ID) private platformId: Object,
    public animalService: AnimalService,
    public agendaService: AgendaService,
    public metaService: MetaService,
    public menuCtrl: MenuController,
    public storageService: StorageService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    private zone: NgZone,
    public eventsService: EventsService,
    public organizationService: OrganizationService) {
    
    addIcons(allIcons);

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';

    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
          const slug = event.url.split(".fr").pop();
          if (slug) {
              this.router.navigateByUrl(slug);
          }
      });
    });

    this.platform.ready().then(() => {
      if ((this.platform.is('ios') || this.platform.is('android')) && !this.platform.is('mobileweb')) {
        StatusBar.setOverlaysWebView({ overlay: false });
      }
    });

    this.authService.loginStatus$.subscribe(async (isLoggedIn) => {
      this.isLoggedIn = isLoggedIn;
      if(isLoggedIn)
        this.requestPush();

      if (isLoggedIn) {
        for (var l of this.languages) {
          if (l['code_short'].toLowerCase() == this.userService.user?.languageCode?.toLowerCase()) {
            this.setLang(l, false)
            break;
          }
        }
      }
    })

    this.authService.logout$.subscribe(async (isLoggedIn) => {
      var alert = await this.alertController.create({
        header: this.translate.instant("Info"),
        subHeader: this.translate.instant('_Logout'),
        message: this.translate.instant('You are disconnected from your user account.'),
        buttons: ['OK'],
      });
      await alert.present();
    });
    this.initPush()


    this.languagesSortedbyName = this.languages.slice(0).sort((a, b) => a['name'].localeCompare(b['name']))
    this.router.events.subscribe(e => {
      if (this.currentLang != null)
        return

      if (this.router.navigated) {
        this.route.queryParamMap.subscribe((p: any) => {
          if (p['params']['lang']) {
            for (var l of this.languages) {
              if (l['code_short'] == p['params']['lang']) {
                this.setLang(l, true)
              }
            }
          } else {
            if (this.storageService.configuration != null && this.storageService.configuration.language != null && this.storageService.configuration.language['code_short'] != null) {
              this.setLang(this.storageService.configuration.language, true)
            } else {
              this.setLangFromNavigator();
            }

            this.languagesSortedbyName = this.languages.slice(0).sort((a, b) => a['name'].localeCompare(b['name']))

            this.storageService.configurationUpdated$.subscribe((configuration) => {
              if (this.storageService.configuration?.language != null && this.storageService.configuration?.language['code_short'] != null) {
                this.setLang(this.storageService.configuration.language, true)
              } else {
                this.setLangFromNavigator();
              }
            })
          }
        }).unsubscribe();
      }
    });

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateMetaTranslations();
    });
  }

  updateMetaTranslations() {
    this.metaService.updateLang();
  }

  updateMeta() {
  }

  ngAfterViewInit() {
    this.openAppsStoreIfUpdateAvailable()
  }


  langSelectionChanged(event: any) {
    for (var _l in this.languages) {
      var l = this.languages[_l];
      if (l['id'] == event) {
        this.setLang(l, false);
        break;
      }
    }
    this.modalLangSelector.dismiss();
    
    //Pour une raison inconnu la méthode normal pour fermer le menu ne fonctionne pas
    //await this.menuCtrl.close('main-menu');
    const menuElement = document.querySelector('ion-menu#main-menu') as HTMLIonMenuElement;
    menuElement.close();
    
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/a', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  langSearchChanged(event: any) {
  }

  async ngOnInit() {
    this.authService.getIsLoggedIn().then(data => {
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))  
      .subscribe((event: NavigationEnd) => {
        this.tabBarsSelectItem(event.url)
      });

      this.translate.setDefaultLang('fr');
      this.translate.use('fr');
  }

  logout() {
    this.authService.logout();
    this.menuCtrl.close();
    this.router.navigate(['/']);
  }

  tabBarsSelectItem(url:string) {
    this.showTabBar = true;

    var tabs = document.querySelectorAll('#sonEspaceSante-tabs a');
    if(tabs.length == 0) {
      setTimeout(() => { this.tabBarsSelectItem(url); }, 1000)
    }

    requestAnimationFrame(() => {
      tabs.forEach(tab => tab.classList.contains('selected') ? tab.classList.remove('selected'): null);
    });

    var found: boolean = false;
    for(let i = 0; i< tabs.length; i++) {
      var ts = tabs[i].getAttribute('tab')?.split(';') ?? []
      for(var t of ts) {
        if(url == '/' + t || url == t || (url == '/' && t == 'homepage')) {
          requestAnimationFrame(() => {
            tabs[i].classList.add('selected');
          });
          found = true;
          break;
        }
      }
      if (found) break;
    }

    if(!found) {
      for(let i = 0; i< tabs.length; i++) {
        var ts = tabs[i].getAttribute('tab')?.split(';') ?? []
        for(var t of ts) {
          if(url.startsWith('/' + t) || url.startsWith(t)) {
            requestAnimationFrame(() => {
              tabs[i].classList.add('selected');
            });
            break;
          }
        }
      }
    }

    if(url.startsWith('/organization-public-animals') || this.userService?.user?.organizationMember?.isOnlyBenevoleWalker()) {
      this.showTabBar = false;
    }
  }
  
  openAppsStoreIfUpdateAvailable = async () => {
    if (Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios') {
      const result = await AppUpdate.getAppUpdateInfo();

      if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
        return;
      }
      if (result.immediateUpdateAllowed) {
        await AppUpdate.performImmediateUpdate();
      } else {
        var c = await this.alertController.create({
          header: this.translate.instant('Update available'),
          message: this.translate.instant('An app update is available, would you like to do it now?'),
          buttons: [
            { text: this.translate.instant('No'), handler: async (d) => {
            } }, 
            { text: this.translate.instant('Yes'), handler: async (d) => { 
              let appId: string | undefined;

              if (this.platform.is('ios')) {
                appId = environment.appStoreId; 
              } else if (this.platform.is('android')) {
                appId = environment.appId;
              }

              await AppUpdate.openAppStore({ appId: appId });
            } }, 
          ]
        })
        await c.present();
      }
    }
    setTimeout(() => { this.openAppsStoreIfUpdateAvailable() }, 60 * 15 * 1000)
  };

  async shareApp() {
    if (this.platform.is('hybrid')) {
      try {
        await Share.share({
          title: this.translate.instant('Share the app'),
          text: this.translate.instant('Discover Her Health Space! It\'s super convenient for tracking your pets\' health (vaccinations, events, etc.). Try it—you\'ll love it!'),
          url: this.platform.is('ios') ? 'https://apps.apple.com/fr/app/son-espace-sante/id' + environment.appStoreId : 'https://play.google.com/store/apps/details?id=' + environment.appId,
          dialogTitle: this.translate.instant('Share the app'),
        });
        console.log('Partage réussi !');
      } catch (error: any) {
        console.error('Erreur lors du partage :', error);
      }
    } else {
      console.warn('Le partage social n\'est disponible que sur un appareil.');
    }
  }

  discussionsCB(event: any) {
    this.router.navigate(['/discussion-list']);
    event.preventDefault();
  }


  deviceIdSetted: string | null = null
  setDeviceId(deviceId:string) {
    if(this.authService.isLoggedIn && (!this.deviceIdSetted || this.deviceIdSetted != deviceId)) {
      this.deviceIdSetted = deviceId
      var type: string = this.platform.is('ios') ? 'ios': this.platform.is('android') ? 'android': 'web';

      var headers = new HttpHeaders({
        'Authorization': this.userService.getHttpHeaders(),
        'content-type': 'application/json'
      });

      let formData: { [key: string]: any } = {};
      formData['deviceId'] = this.pushNotificationsTokenValue;
      formData['deviceType'] = type;
      this.http.post(environment.API_URL + 'userProfile/ws_private/SetDeviceId/', JSON.stringify(formData), {headers : headers}).subscribe(async (response: any) => {
      });
    }
  }

  async initPushPermissionGranted() {
    const { token } = await FirebaseMessaging.getToken(this.pushNotificationsOptions);
    this.pushNotificationsTokenValue = token;

    this.setDeviceId(this.pushNotificationsTokenValue)

    FirebaseMessaging.addListener('notificationReceived', async (event) => {
      var notification: { [key: string]: any } = event['notification']

      console.log(notification)

      this.notifTitle = null;
      this.notifBody = null;
      this.notifUrl = null;
      if(notification['data']['aps'] != null && notification['data']['aps']['alert'] != null && notification['data']['aps']['alert']['title'] != null) { //IOS
        this.notifTitle = notification['data']['aps']['alert']['title'];
        this.notifBody = notification['data']['aps']['alert']['body'];
      } else { //Android
        this.notifTitle = notification['title'];
        this.notifBody = notification['body'];
      }
      if (notification['data']['url'] !== undefined) {
        this.notifUrl = notification['data']['url']
      }

      this.notifId = notification['data']['notificationId']
      var action = notification['data']['action'] || null;

      if (action == 'FriendRequest') {
        this.eventsService.publish('FriendRequest', notification['data']);
      } else if (action == 'FriendRequestAccepted') {
        this.eventsService.publish('FriendRequestAccepted', notification['data']);
      }
    });


    FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
      var notification: { [key: string]: any } = event['notification']

      if (notification['data']['url'] !== undefined) {
        this.authService.getIsLoggedIn().then(data => {
          if(!this.authService.isLoggedIn) {
            this.router.navigate(['/login']);
            return
          } else {
            if(!this.userService.user) return
            this.animalService.dbGetAnimalsOfUser(this.agendaService, false, this.userService.user.id).then((data: Animal[] | null) => {
              if(!this.userService.user) return
              this.agendaService.dbGetEventsOfUser(this.userService.user.id).then((data: AgendaEvent[] | null) => {
                let split = notification['data']['url'].split('#')
                this.router.navigate([split['0']], { fragment: split['1']});

                let formData = {};
                var headers = new HttpHeaders({
                  'FRONTENDNAME': 'Canicompet',
                  'Authorization': this.userService.getHttpHeaders(),
                  'content-type': 'application/json'
                });
                if(notification['data']['notificationId']) {
                  this.http.post(environment.API_URL + 'userProfile/ws_private/' + notification['data']['notificationId'] + '/notifRead/', JSON.stringify(formData), {headers : headers}).subscribe((response) => {
                  });
                }
              });
            });
          }
        });

      }
    });
  }

  pushIsInit = false
  async initPush() {

    if (!isPlatformBrowser(this.platformId))
      return;

    if(this.pushNotificationsRunning) return
    this.pushNotificationsRunning = true
    initializeAppFirebase(environment.firebase);

    this.pushNotificationsOptions = {
      vapidKey: environment.firebase.vapidKey,
    };
    if (Capacitor.getPlatform() === 'web') {
      this.pushNotificationsOptions.serviceWorkerRegistration =
        await navigator.serviceWorker.register('firebase-messaging-sw.js', {scope: "/firebase-cloud-messaging-push-scope"});
    }
  }

  async requestPush() {
    if(this.pushIsInit)
      return
    this.pushIsInit = true;

    var result = await FirebaseMessaging.checkPermissions();
    if (result.receive == 'prompt' && this.pushNotificationsOptionsAlertControler == null) {
      var result = await FirebaseMessaging.requestPermissions();
      if (result.receive === 'granted') { 
        this.initPushPermissionGranted() 
      }
    }
    else if (result.receive == 'denied') {
    } else {
      this.initPushPermissionGranted()
    }

  }


}
